"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var castISOToDate = function (iso) {
    var _a = iso.split("-").map(Number), year = _a[0], month = _a[1], _b = _a[2], day = _b === void 0 ? 1 : _b;
    return new Date(year, month - 1, day);
};
exports.default = castISOToDate;
